import { useEffect, useState, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { API } from '../../../../Common/lib/api';
import { Storage } from '../../../../Common/lib/storage';
import { getUserSession } from '../../../../Common/lib/Session';
import { AiOutlineFilePdf, AiOutlinePicture, AiOutlineVideoCamera } from "react-icons/ai"; // MIT License
import { GiPathDistance } from "react-icons/gi"
import { Menu, Transition } from "@headlessui/react";
import { HiOutlineDotsHorizontal } from "react-icons/hi";


export default function MyFiles(props) {
  const [session, setSession] = useState();
  const [projects, setProjects] = useState([]);
  const [totalProjects, setTotalProjects] = useState();
  const [loading, setLoading] = useState(true);

  const fetchSession = async () => {
    const session = await getUserSession();
    setSession(session);
    fetchData(session.id);
  };

  const parseDataVisualization = (dataVisualization) => {
    if (!dataVisualization) {
      return [];
    }

    const visualizationArray = JSON.parse(dataVisualization);
    return visualizationArray.map((item) => {
      return {
        title: item.title || '',
        desc: item.desc || '',
        type: item.type || '',
        s3Link: item.s3Link || '',
        id: item.id || '',
        archived: item.archived,
        approved: item.approved,
        size: item.size,
      };
    });
  };

  const fetchData = async (userId) => {
    const params = {
      createdByUserId: userId,
    };
    const projectsResponse = await API.projects.list(params);
    const projectsData = projectsResponse.data.listProjects?.items || projectsResponse.data?.items || [];

    let projectsList = [];

    projectsData.forEach(project => {
      if(project?.dataVisualization?.length && project.publishStatus !== "archived"){
        let dataVisualization = JSON.parse(project.dataVisualization)
        for(let i = 0; i < dataVisualization.length; i++){
          if(!dataVisualization[i].archived){
            projectsList.push({
              ...project,
              dataVisualization: parseDataVisualization(project.dataVisualization)
            })
            break;
          }
        }
      }
    });

    setTotalProjects(projectsData.length);
    setProjects(projectsList);

    setLoading(false);
  };

  /**
   * Will delete (archive) a chosen data visualization. It will also delete the visualization approval request if there was one.
   *
   * @param {*} visualizationArray The array of data visualizations.
   * @param {*} index The index of the selected visualization.
   * @param {*} project The project the visualization is in.
   */
  const deleteVisualization = async (visualizationArray, index, project) => {
    try {
      //if this visualization was the last non-archived visualization in the project, dont show it anymore
      let visibleVisualizations = 0;

      visualizationArray.forEach(visualization => {
        if(!visualization.archived){
          visibleVisualizations++;
        }
      })

      if(visibleVisualizations === 1){
        setProjects(projects.filter(filterProject => filterProject.id !== project.id))
      }

      await Storage.remove(visualizationArray[index].s3Link, { level: 'public' });

      visualizationArray.splice(index, 1);

      await API.projects.update({
        id: project.id,
        dataVisualization: JSON.stringify(visualizationArray)
      });

      let visualization = {
        id: visualizationArray[index].id,
        title: visualizationArray[index].title
      }

      await API.graphql({
        query: getAdministrationByVisualization,
        variables: { visualization: JSON.stringify(visualization) },
      }).then(async (result) => {
        let pk = result.data.getAdministrationByVisualization.items[0]?.PK;

        if(pk){
          await API.graphql({
            query: deleteAdministration,
            variables: {
              input: {
                PK: pk,
                Date: result.data.getAdministrationByVisualization.items[0].Date
              }
            }
          })
        }
      })

      props.setNotificationShow(true);
      props.setNotification({
          status: true,
          title: "Visualization Deleted",
          message: `Your visualization  "${visualizationArray[index].title}" has been deleted.`
      });
    } catch (error) {
      // console.log(error)
      props.setNotificationShow(true);
      props.setNotification({
          status: false,
          title: "Visualization Delete Failed",
          message: `Your visualization "${visualizationArray[index].title}" failed to delete.`
      });
    }
  }

  useEffect(() => {
    fetchSession();
  }, []);

  const getThumbnailByType = (type) => {
    if (type === 'image') {
      return (
        <div className="h-32 w-32 lg:h-3/5 lg:w-3/5 p-2 bg-gray-100 rounded border dark:bg-gray-600 dark:border-gray-500">
          <div className="mx-auto flex items-center justify-center">
            <AiOutlinePicture className="mb-3 h-14 w-14 text-gray-400 dark:text-white" aria-hidden="true" />
          </div>
          <div className="text-center">
            <p className="bg-green-500 p-0.5 rounded text-xs text-white font-semibold text-center">
              Image
            </p>
          </div>
        </div>
      )
    } else if (type === 'pdf') {
      return (
        <div className="h-32 w-32 lg:h-3/5 lg:w-3/5 p-2 bg-gray-100 rounded border dark:bg-gray-600 dark:border-gray-500">
          <div className="mx-auto flex items-center justify-center">
            <AiOutlineFilePdf className="mb-3 h-14 w-14 text-gray-400 dark:text-white" aria-hidden="true" />
          </div>
          <div className="text-center">
            <p className="bg-red-500 p-0.5 rounded text-xs text-white font-semibold text-center">
              PDF
            </p>
          </div>
        </div>
      );
    } else if (type === 'video') {
      return (
        <div className="h-32 w-32 lg:h-3/5 lg:w-3/5 p-2 bg-gray-100 rounded border dark:bg-gray-600 dark:border-gray-500">
          <div className="mx-auto flex items-center justify-center">
            <AiOutlineVideoCamera className="mb-3 h-14 w-14 text-gray-400 dark:text-white" aria-hidden="true" />
          </div>
          <div className="text-center">
            <p className="bg-blue-500 p-0.5 rounded text-xs text-white font-semibold text-center">
              Video
            </p>
          </div>
        </div>
      )
    } else if (type.includes('track')) {
      return (
        <div className="h-32 w-32 lg:h-3/5 lg:w-3/5 p-2 bg-gray-100 rounded border dark:bg-gray-600 dark:border-gray-500">
          <div className="mx-auto flex items-center justify-center">
            <GiPathDistance className="mb-3 h-14 w-14 text-gray-400 dark:text-white" aria-hidden="true" />
          </div>
          <div className="text-center">
            <p className="bg-yellow-800 p-0.5 rounded text-xs text-white font-semibold text-center">
              GPX/GeoJSON
            </p>
          </div>
        </div>
      )
    }
    else {
      return null;
    }
  };

  return (
    <div className="container py-8 px-8 mx-0 min-w-full border bg-gray-50 shadow rounded-xl dark:bg-gray-800 dark:border-gray-700">
      {loading ? (
        <p className="text-center dark:text-white">Loading...</p>
      ) : (
        totalProjects > 0 ? (
          <div className="grid grid-cols-1 gap-4">
            {projects.length > 0 ? (
              <>
                {projects.map((project) => (
                  <div key={project.id || project.PK}>
                    <h2 className="text-xl font-bold mb-4 dark:text-white">{project.title}</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      {project.dataVisualization.map((visualization, index) => {
                        if(!visualization.archived){
                        return (<div
                          key={project.id + index}
                          className="bg-white border border-gray-300 rounded-md p-3 flex flex-col items-center space-y-2 relative dark:bg-gray-500 dark:border-gray-500"
                          style={{ height: '225px' }}
                        >
                          <Menu>
                            <div>
                              <Menu.Button
                                data-cy={project.title + "-options"}
                                className="group absolute right-4 top-2 justify-center text-sm font-medium text-gray-700 hover:text-gray-900"
                              >
                                <HiOutlineDotsHorizontal className="flex-shrink-0 -mr-1 ml-1 h-6 w-6 text-gray-400 group-hover:text-gray-500" />
                              </Menu.Button>
                            </div>
                            <Transition
                              as={Fragment}
                              enter="transition ease-out duration-100"
                              enterFrom="transform opacity-0 scale-95"
                              enterTo="transform opacity-100 scale-100"
                              leave="transition ease-in duration-75"
                              leaveFrom="transform opacity-100 scale-100"
                              leaveTo="transform opacity-0 scale-95"
                            >
                              <Menu.Items className="z-40 origin-top-right absolute right-0 mt-0 w-36 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                <div className="py-1 " data-cy="options">
                                  <>
                                    { (session?.edit_locked !== "true" && !project?.locked) &&
                                      <Menu.Item>

                                        <Link
                                          className="w-full"
                                          data-cy="edit-visualization"
                                          to={`/visualization/edit?projectId=${project.id}&index=${index}`}
                                        >
                                          <p className="text-right mb-0 text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100">
                                            Edit
                                          </p>
                                        </Link>
                                      </Menu.Item>
                                    }
                                    <Menu.Item>
                                      <button
                                        className="w-full"
                                        data-cy="delete-visualization"
                                        onClick={() => {deleteVisualization(project.dataVisualization, index, project)}}
                                      >
                                        <p className="text-right mb-0 text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100">
                                          Delete
                                        </p>
                                      </button>
                                    </Menu.Item>
                                  </>
                                </div>
                              </Menu.Items>
                            </Transition>
                          </Menu>
                          {getThumbnailByType(visualization.type)}
                          <h3 className="text-lg font-bold text-center border-b pb-2 border-gray-200 w-full break-all truncate dark:text-white">{visualization.title}</h3>
                          <p className="text-sm text-center h-12 overflow-hidden line-clamp-2 break-all dark:text-white" style={{wordBreak: "break-word"}}>{visualization.desc}</p>
                        </div>)
                      }})}
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <p className="text-center dark:text-white">You have not added any visualizations yet.</p>
            )}
          </div>
        ) : (
          <p className="text-center">You have not submitted any projects yet.</p>
        )
      )}
    </div>
  );
}